import { apiClientV2 } from '../../apiClient';

const baseURL = process.env.VUE_APP_API_ORDER_URL

export const getDeliveryStatusWidget = async (view) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/widget/1',
    params: {
      view,
    }
  })

  return response?.data
}

export const getDeliveryAchievementWidget = async (params) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/widget/2',
    params
  })

  return response?.data
}

export const getTopCustomerListWidget = async (params) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/widget/3',
    params,
  })

  return response?.data
}

export const getTopVendorRejectedDelivery = async (params) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/widget/4',
    params,
  })

  return response?.data
}

export const getTopVendorWithMostLateDelivery = async (params) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/widget/5',
    params,
  })

  return response?.data
}

export const getOnTimeVendorDelivery = async (params) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/widget/6',
    params,
  })

  return response?.data
}
